<template>
	<div class="basicInfo" ref="basicInfo">
		<div class="basicInfo_comm basicInfo_user">
			<div class="basicInfo_user_img">
				<img :src="userInfo.avatar_url" />
				<div class="edit_img" @click="editAvatarUrl">
					<span class="iconfont">&#xe605;</span>
					<span>修改</span>
				</div>
			</div>
			<div class="basicInfo_user_right">
				<h5>{{userInfo.name}}</h5>
				<p>账号：{{userInfo.account}}</p>
				<!-- <p>{{userInfo.phone}}</p>
				<div class="edit_pass">
					<el-button size="small" @click="editPass">修改密码</el-button>
				</div> -->
			</div>
			<div v-if="maSrc" class="basicInfo_user_ma">
							<img class="ma-class" :src="maSrc" alt="二维码">
							<div>
								<p>微信扫码关注"豆包知道数据助</p>
								<p>手"公众号可实时接收订单消息</p>
								<P style="color: red">请用讲师端绑定的微信扫描关注</P>
							</div>
							
						</div>
		</div>
		<div class="basicInfo_comm basicInfo_nickName">
			<div class="basicInfo_comm_p">
				昵称
			</div>
			<div class="basicInfo_comm_li">
				<template v-if="name">
					<el-input v-model="userInfo.name" placeholder="请输入修改昵称" class="basicInfo_inp"/>
					<div class="oper">
						<el-button size="small" @click="cancelEdit('name')">取消</el-button>
						<el-button size="small" type="primary" @click="sureEdit('name')">确定</el-button>
					</div>
				</template>
				<template v-else>
					<p class="text">{{userInfo.name}}</p>
					<p class="edit" @click="editInfo('name')">修改</p>
				</template>
			</div>
		</div>
		<!-- <div class="basicInfo_comm basicInfo_nickName">
			<div class="basicInfo_comm_p">
				分享标题
			</div>
			<div class="basicInfo_comm_li">
				<template v-if="share_title">
					<el-input v-model="userInfo.share_title" placeholder="请输入修改分享标题" class="basicInfo_inp"/>
					<div class="oper">
						<el-button size="small" @click="cancelEdit('share_title')">取消</el-button>
						<el-button size="small" type="primary" @click="sureEdit('share_title')">确定</el-button>
					</div>
				</template>
				<template v-else>
					<p class="text">{{userInfo.share_title}}</p>
					<p class="edit" @click="editInfo('share_title')">修改</p>
				</template>
			</div>
		</div> -->
		<div class="basicInfo_comm">
			<div class="basicInfo_comm_p">
					<p>
					<span>讲师介绍</span>
						<el-popover width="400"  	placement="top-start"
						trigger="hover" >
						<span>讲师介绍：需包含但不仅限于：讲师资质（如心理、法律、健身等强依赖专业性的）、行业背景、历史成就等;“我是谁”+“我的学历背景”/“我的过往经验”/“擅长什么”等元素。</span>
     		<img slot="reference"   class="question" src="http://img-dbzd.doubaozhidao.com/20220815/XFNwEwk4pDh68ZKDGA6EkMPYNXPP3aM41660554235287.png?x-oss-process=image/quality,q_80/format,png" alt="">
    </el-popover>
				    <span class="span-hint">(讲师介绍需在30～200字之间)</span>
		
				</p>
				
			</div>
			<div class="basicInfo_comm_li">
				<p class="text">{{userInfo.desc}}</p>
				<p class="edit" @click="editInfo('desc')">修改</p>
			</div>
		</div>
		<div class="basicInfo_comm">
			<div class="basicInfo_comm_p">
				安全设置
			</div>
			<div class="basicInfo_comm_li">
				<p class="text">
				登陆密码</p>
				<p class="edit" @click="editPass">修改</p>
			</div>
			<div class="basicInfo_comm_li">
				<p class="text">
				绑定手机号({{userInfo.phone}})</p>
				<p class="edit" @click="editPhoneFlag = true">修改</p>
			</div>
		</div>
		<div class="basicInfo_comm">
			<div class="basicInfo_comm_p" style="justify-content: flex-start;">
				绑定微信  <span style="font-size: 14px;color:000;">（绑定后可在微信公众号 <span style="color:#02A7F0;">“豆包知道助手”</span>查看实时收益数据并提现）</span>
			</div>
			<div class="basicInfo_comm_li" v-if="userInfo.is_wechat == 0">
				<p class="text">
					<img src="~@/assets/image/wx.png" alt=""/>
					微信账号
				</p>
				<p class="wx_acc wx_acc_no" @click="bind('wx')"><span class="iconfont">&#xe71b;</span><span>绑定</span></p>
			</div>
			<template v-else>
				<div class="basicInfo_comm_li" v-for="(item, index) in userInfo.weichat" :key="index">
					<p class="text">
						<img :src="item.avatar_url" alt="" v-if="item.avatar_url" style="width:23px;height:23px;border-radius:100%"/>
						<img src="~@/assets/image/wx.png" alt="" v-else/>
						<span>{{item.wx_name ? item.wx_name : '微信账号'}}</span>
					</p>
					<p class="wx_acc"><span class="iconfont">&#xe7fb;</span><span>已绑定</span></p>
				</div>
			</template>
		</div>
		<div class="basicInfo_comm" v-if="expireObj[userInfo.expire_type].showBasicInfo">
			<div class="basicInfo_comm_p">
				讲师有效期
			</div>
			<div class="basicInfo_comm_li">
				<p class="text">
					{{ userInfo.expire_time }}
				</p>
			</div>
		</div>
		<!-- <div class="basicInfo_comm">
			<div class="basicInfo_comm_p">
				<span>快手号</span>
				<span style="color:#4e70f2;font-size:14px;font-weight:normal;cursor:pointer" @click="bind('dy')">添加</span>
			</div>
			<div class="basicInfo_comm_li" v-for="(item, index) in dyCodeList.available" :key="index">
				<p class="text">
					<img :src="item.avatar" alt="" style="width:23px;height:23px;border-radius:100%"/>
					{{item.nickname}}
				</p>
				<p class="wx_acc"><span class="iconfont">&#xe7fb;</span><span>已绑定</span></p>
			</div>
			<div class="basicInfo_comm_li" v-for="(item, index) in dyCodeList.overtime" :key="index">
				<p class="text">
					<img :src="item.avatar" alt="" style="width:23px;height:23px;border-radius:100%"/>
					{{item.nickname}}
				</p>
				<p class="wx_acc wx_acc_no" @click="reloadBind"><span class="iconfont">&#xe71b;</span><span>重新授权</span></p>
			</div>
		</div> -->
		<!-- <div class="basicInfo_comm">
			<div class="basicInfo_comm_p">
				其他权限
			</div>
			<div class="basicInfo_comm_li">
				<p class="text">课程公共池开关</p>
				<el-switch
				:value="value1"
				@change="changeValue"
				:disabled="disabled"
				>
				</el-switch>
			</div>
			<div class="basicInfo_comm_li">
				<template v-if="userInfo.public_visible == 2">
					<p v-if="userInfo.self_push_amount * 1 < 100000" style="color: red;font-size:12px">(您还未达到开启条件，暂无法开启)</p>
					<p v-else  style="color: red;font-size:12px">(一旦开启将无法关闭请谨慎操作)</p>
				</template>
			</div>
		</div> -->
		<uploader-img ref="uploaderImg" v-model="userInfo.avatar_url" cropperW="200" cropperH="200" :ratio="[5,5]" :isAddSucaiFlag="false" :conFlag="false" @change="changeFile"></uploader-img>
		<el-dialog
			title="讲师介绍"
			:visible.sync="desc"
			width="30%"
			>
			<div class="desc_con">
				<el-input
					type="textarea"
					placeholder="请输入讲师介绍"
					:autosize="{ minRows: 4, maxRows: 6}"
					v-model="userInfo.desc"
					maxlength="200"
					show-word-limit
				/>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancelEdit('desc')">取消</el-button>
				<el-button size="small" type="primary" @click="sureEdit('desc')">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog
			title="快手APP扫码授权"
			:visible.sync="deCodeVisible"
			width="664px"
			height="400px"
			custom-class="wxBind1"
			@close="handleClosede"
			>
			<div class="qrcode">
				<!-- <img :src="deCode" style="height: 200px;" alt=""> -->
				<iframe :src="deCode" border="0" frameborder="no" style="width:180px;height:180px" v-if="deCodeVisible"></iframe>
				<p style="width: 150px">
					<span>1、一键发布视频到快手</span>
				</p>
				<p style="width: 150px">
					<span>2、查看小程序收益</span>
				</p>
				<p style="width: 150px">
					<span>3、获取快手粉丝数据</span>
				</p>
			</div>
		</el-dialog>
		<el-dialog
			title="微信扫码绑定"
			:visible.sync="qrCodeVisible"
			width="664px"
			height="300px"
			custom-class="wxBind"
			@close="handleClose"
			>
			<div class="qrcode">
				<vue-qr :text="wx_url" :size="120" :logoSrc="require('@/assets/image/logo-231019.png')" :margin="0"></vue-qr>
				<p>
					<span>绑定后可在微信公众号</span>
					<span style="color:#0491FF">“豆包知道助手”</span>
					<span>查看实时收益数据并体现</span>
				</p>
				<p style="margin-top: 6px">
					挂载流程：绑定抖音号<span style="color: red">（不绑无收益）</span>→上传课程→发抖音挂载课程。
				</p>
			</div>
		</el-dialog>
		
		<edit-bind-phone v-model="editPhoneFlag" @sure="sureBindPhone"></edit-bind-phone>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	import uploaderImg from '@/components/upload/upload.vue'
	import vueQr from 'vue-qr'
	import editBindPhone from '@/components/editBindPhone/editBindPhone.vue'
	import { expireObj } from '@/components/teacherExpire/mixin.js'
	export default {
		name: 'BasicInfo',
		data() {
			return {
				name: false,
				desc: false,
				dyCodeList:{
					available:[],
					overtime: []
				},
				share_title: false,
				deCodeVisible: false,
				deCode: '',
				timer: null,
				qrCodeVisible: false,
				wx_url: localStorage.getItem('bind_wx_url'),
				editPhoneFlag: false,
				maSrc:'',//二维码
				expireObj: expireObj
			}
		},
		components: {
			'uploader-img': uploaderImg,
			'vue-qr':vueQr,
			'edit-bind-phone': editBindPhone
		},
		methods: {
			...mapActions('login', ['getUserInfo', 'openpublicvisible', 'loginEditinfo', 'checkwechat']),
			...mapActions('createDynamic', ['taCodeList', 'getTacode']),
			...mapActions('bind', ['ksAuthorize']),
			...mapActions('help', ['wechatQcode']),
			async wechatQcodeFun(){
				let res = await this.wechatQcode()
				this.maSrc=res.qcode			
			},
			editPass() {
				let breadCrumbList = this.breadCrumbList
				breadCrumbList[2] = {
					title: '修改密码',
					path: this.staticPath + 'resetPassword'
				}
				localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList))
				this.$router.push({
					path: this.staticPath + 'resetPassword'
				})
			},
			changeValue(value) {
				this.$set(this.userInfo, 'public_visible', 1)
				this.openpublicvisible()
			},
			editAvatarUrl() {
				this.$refs.uploaderImg.dialogVisible = true
			},
			editInfo(type) {
				this[type] = true
			},
			cancelEdit(type) {
				this[type] = false
			},
			async sureEdit(type) {
				try {
					if(this.userInfo.desc.length<30  && type=='desc'){
						this.$message({
						type: 'error',
						duration: 3000,
						message: '讲师介绍不得少于30个字符'
					})
					return
					}
					this[type] = false
					await this.loginEditinfo({[type]: this.userInfo[type]})
					if(type == 'avatar_url') {
						localStorage.setItem('avatar_url', this.userInfo.avatar_url)
					} else if(type == 'name'){
						localStorage.setItem('name', this.userInfo.name)
					}
					this.$message({
						type: 'success',
						duration: 3000,
						message: '修改成功'
					})
				} catch (error) {
					
				}
			},
			changeFile(url) {
				this.sureEdit('avatar_url')
			},
			handleClose(done) {
				// done()
			},
			async getTaCodeList() {
				let res = await this.taCodeList()
				// console.log(res, 'pppwwwwwwwwww')
				this.dyCodeList = res
			},
			bind(type) {
				if(type == 'wx') {
					this.qrCodeVisible = true
				} else {
					this.userInfo.is_wechat == 0  ? this.$confirm('你还没有绑定微信，请先绑定完微信再添加快手账号', '提示', {
					confirmButtonText: '去绑定',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(() => {
						this.deCodeVisible = false
						this.qrCodeVisible = true
						// this.$router.push('/createDynamic')
					}) : this.deCodeVisible = true
				}
			},
			async checkWxBind() {
				let res = await this.checkwechat()
				if(res.is_wechat == 1) {
					this.qrCodeVisible = false
					this.getUserInfo()
				}
				setTimeout(() => {
					if(this.qrCodeVisible) {
						this.checkWxBind()
					}
				}, 2000)
			},
			async getDeCode() {
				let res  = await this.ksAuthorize()
				console.log(res, 'ppp')
				this.deCode = res.redirect_url + '&size=180'
				// console.log(res, 'oooiuurere')
			},
			async checkDyBind() {
				let res = await this.taCodeList()
				if(res.available.length == this.dyCodeList.available.length) {
					this.timer = setTimeout(() => {
						this.checkDyBind()
					}, 2000)
				} else {
					this.getTaCodeList()
					this.deCodeVisible = false
				}
			},
			handleClosede() {
				if(this.timer) {
					clearTimeout(this.timer)
				}
			},
			reloadBind() {
				this.deCodeVisible = true
			},
			sureBindPhone(value) {
				this.userInfo.phone = value
			}
		},
		computed: {
			...mapState(['breadCrumbList']),
			...mapState('login', ['userInfo']),
			disabled() {
				return this.userInfo.self_push_amount * 1 < 100000 || this.userInfo.public_visible == 1 ? true : false
			},
			value1() {
				console.log(this.userInfo.public_visible, 'oooooooooooo')
				return this.userInfo.public_visible == 1 ? true : false
			}
		},
		created() {
			this.getUserInfo()
			// this.getTaCodeList()
			this.$nextTick(() => {
				this.$refs.basicInfo.parentNode.classList.add('content_basinfo')
			})
			this.wechatQcodeFun()
		},
		beforeRouteLeave(to,form,next) {
			this.$refs.basicInfo.parentNode.classList.remove('content_basinfo')
			next()
		},
		filters: {
			handlePhone(value, title) {
				return value ? value.slice(0,3) + '****' + value.slice(value.length - 3,value.length): title
			}
		},
		watch: {
			deCodeVisible(news) {
				if(news) {
					this.getDeCode()
					this.checkDyBind()
				}
			},
			qrCodeVisible(news) {
				if(news) {
					this.checkWxBind()
				}
			},
			'userInfo.is_wechat'(){
				if(this.userInfo.is_wechat==0){
					this.qrCodeVisible=true
				}
			}
		}
	}
</script>
<style lang="less">
	.content_basinfo {
		background-color: transparent!important;
		box-shadow: none!important;
		border-radius: 0!important;
		padding:0!important;
	}
	.basicInfo_inp {
		width: 400px;
		height: 32px;
		.el-input__inner {
			height: 32px;
			line-height: 32px;
		}
	}
	.wxBind1{
		height: 450px;
		.el-dialog__header {
			padding: 16px 24px;
			border-bottom: 1px solid #EEEEEE;
			.el-dialog__title {
				font-size: 16px;
				font-weight: 500;
				color: #333333;
				line-height: 24px;
			}
		}
		.el-dialog__body {
			padding: 24px;
			display: flex;
			flex-direction: column;
			justify-content: center;
		}
		.qrcode {
			display: flex;
			flex-direction: column;
			align-items: center;
			p {
				font-size: 14px;
				color: #000000;
				margin-top: 20px;
				span {
					line-height: 20px;
				}
			}
		}
	}
</style>
<style lang="less" scoped>
	.basicInfo_comm {
		background-color: #fff;
		padding: 20px;
		position: relative;
		&:not(:last-child) {
			margin-bottom: 20px;
		}
		.basicInfo_comm_p {
			font-size: 16px;
			color: #888a95;
			line-height: 22px;
			margin-bottom: 16px;
			font-weight: 600;
			display: flex;
			justify-content: space-between;
				.span-hint{
				font-size: 12px;
				margin-left: 10px;
			}
		}
		.basicInfo_comm_li {
			display: flex;
			justify-content: space-between;
			.text {
				font-size: 14px;
    			color: #37383c;
				display: flex;
				align-items: center;
				img {
					margin-right: 10px;
				}
			}
			.edit {
				font-size: 14px;
    			color: #4e70f2;
				cursor: pointer;
				white-space: nowrap;
				margin-left: 12px;
			}
			&:not(:last-child) {
				margin-bottom: 12px;
			}
			.wx_acc {
				padding: 0 6px;
				height: 20px;
				border-radius: 10px;
				font-size: 12px;
				border: 1px solid #32b242;
				color: #32b242;
				display: flex;
				align-items: center;
				justify-content: center;
				.iconfont {
					margin-right: 2px;
				}
			}
			.wx_acc_no {
				border: 1px solid red;
				color:red;
				cursor: pointer;
			}
			.oper {
				display: flex;
				align-items: center;
			}
		}
	}
	.basicInfo_user {
		display: flex;
		padding-bottom: 40px;
		.basicInfo_user_img {
			width: 100px;
			height: 100px;
			margin-right: 20px;
			border-radius: 50%;
			position: relative;
			overflow: hidden;
			.edit_img {
				position: absolute;
				left: 0;
				bottom: 0px;
				width: 100%;
				background-color: rgba(0,0,0,.5);
				height: 30px;
				color: #fff;
				z-index: 99;
				text-align: center;
				line-height: 30px;
				transition: .5s;
				font-size: 12px;
				transform: translateY(100%);
				cursor: pointer;
				.iconfont {
					margin-right: 2px;
				}
			}
			&:hover .edit_img {
				transform: translateY(0%);
			}
		}
		img {
			width: 100%;
			height: 100%;
		}
		.basicInfo_user_right {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			padding: 16px 0;
			h5 {
				font-size: 20px;
				font-weight: 600;
				color: #37383c;
				line-height: 28px;
			}
			p {
				font-size: 14px;
				color: #37383c;
				line-height: 14px;
			}

			.edit_pass {
				margin-top: 12px;
			}
		}
		.basicInfo_user_ma {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					align-items: center;
					padding: 16px 0;
					position: absolute;
					top: 0;
					right: 20px;
					height: 100px;
					.ma-class{
						width: 85px;
						height: 85px;
					}
					p {
						font-size: 12px;
						color: #37383c;
						line-height: 18px;
					}
				
				}
	}
	.basicInfo {
		

		.basicInfo_introduction {
			margin-top: 40px;

			h5 {
				font-size: 16px;
				font-weight: 400;
				color: #000000;
				line-height: 16px;
				margin-bottom: 8px;
			}

			p {
				font-size: 14px;
				font-weight: 400;
				color: #909399;
				line-height: 24px;
			}
		}
		.switch_flag {
			display: flex;
			align-items: center;
			margin-top: 12px;
			>span {
				font-size: 16px;
				color: #000;
				margin-right: 8px;
				line-height: 20px;
				margin-bottom: 2px;
				&.is_active {
					color: #409eff;
				}
			}
			>p {
				margin-left: 12px;
			}
		}
	}
	.question{	
		position: relative;
		left: 5px;
		top: 5px;
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}
</style>
